var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(
          _vm.params &&
          _vm.params.data &&
          _vm.params.data.active_trip &&
          _vm.params.data.active_trip.trip_id
        )?_c('v-btn',_vm._g(_vm._b({attrs:{"depressed":"","small":"","color":"primary"},on:{"click":_vm.goToTrip}},'v-btn',attrs,false),on),[_vm._v(" "+_vm._s(_vm.params.data.active_trip.trip_id)+" ")]):_vm._e()]}}])},[_c('span',[_vm._v("View")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }